import { defineStore } from "pinia";
import {computed, ref, watch} from "vue";
import { useWindowSize } from "@vueuse/core";

export const useNeoStore = defineStore('neo', () => {
    const asideExpanded = ref(false);
    const panelWidth = ref(0);

    const toggleAside = () => { asideExpanded.value = !asideExpanded.value; };
    return { asideExpanded, toggleAside, panelWidth };
});
